import {
  GifSend,
  JpgPngFacilitiesart,
  PngFooterback,
  PngLogo,
  PngPressure,
} from "../assets";
import { useEffect, useState } from "react";

import Footer from "../components/Footer";
import Modal from "react-modal";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Twitter } from "react-feather";

export default function Contactus() {
  const form = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [messageError, setMessageError] = useState("");

  const handleNameChange = (e) => {
    if (e.target.value === "") {
      setNameError("Name is required");
    } else {
      setNameError("");
    }
    setName(e.target.value);
  };
  const handleEmailChange = (e) => {
    if (e.target.value === "") {
      setEmailError("Email is required");
    } else {
      setEmailError("");
    }
    setEmail(e.target.value);
  };
  const handleSubjectChange = (e) => {
    if (e.target.value === "") {
      setSubjectError("Subject is required");
    } else {
      setSubjectError("");
    }
    setSubject(e.target.value);
  };
  const handleMessageChange = (e) => {
    if (e.target.value === "") {
      setMessageError("Message is required");
    } else {
      setMessageError("");
    }
    setMessage(e.target.value);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_pxss1gf2",
        "template_le9x0er2",
        form.current,
        "7xAcUTkAwtio_EIZ822",
      )
      .then(() => {
        setIsModalOpen(true);
        setIsError(false);
        form.current.reset();
      });
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    if (isModalOpen) {
      const timer = setTimeout(() => {
        closeModal();
      }, 2500);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isModalOpen]);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      {" "}
      <section className="about__hero">
        <img
          loading="lazy"
          className="about__hero__img"
          src={JpgPngFacilitiesart}
          alt="Knights Home Service"
        />
        <div className="about__hero__content">
          <div className="about__hero__content__heading">Contact Us</div>
          <div className="about__hero__content__text">
            Have questions or need a free quote? Contact us today for expert
            cleaning services tailored to your needs. We’re here to help—call,
            email, or reach out through our online form!
          </div>
        </div>
      </section>{" "}
      <section className="contactusformsection">
        <div className="contactusformsection__content">
          <div
            className="contactusformsection__content__left"
            style={{
              marginTop: "4em",
            }}
          >
            <form
              className="contact__content__left contact__content__left__reverse"
              ref={form}
              onSubmit={sendEmail}
            >
              <Input
                name="name"
                type="text"
                label="Name"
                title="Name"
                required={true}
                onChange={handleNameChange}
                error={nameError}
              />
              <div className="contact__content__left__row">
                <Input
                  type="email"
                  label="Email"
                  title="Email"
                  name="Email"
                  required={true}
                  onChange={handleEmailChange}
                  error={emailError}
                />
                <Input name="tel" type="tel" label="Phone" title="Phone" />
              </div>
              <Input
                type="Subject"
                label="Subject"
                title="Subject"
                name="Subject"
                required={true}
                onChange={handleSubjectChange}
                error={subjectError}
              />
              <Textareas
                className="contact__content__left__input__field__textarea"
                textarea
                label="How we can help you?"
                required={true}
                name="Message"
                onChange={handleMessageChange}
                error={messageError}
              />
              <button
                type="submit"
                value="Send"
                title="Submit"
                className="contact__content__left__button"
              >
                Submit
              </button>
            </form>
            <Modal isOpen={isModalOpen} contentLabel="Form Submission Status">
              <div className={`modal-content ${isError ? "error" : "success"}`}>
                <img
                  loading="lazy"
                  className="sendgif"
                  src={GifSend}
                  alt="Knights Home Service"
                />
                <h2>
                  {isError
                    ? "Error submitting the form."
                    : " We have received your request successfully. We will contact you soon."}
                </h2>
              </div>
            </Modal>
          </div>
          <div className="contactusformsection__content__left">
            <div className="contactusformsection__content__left__content">
              <div className="contactusformsection__content__left__content__heading">
                Contact Information
              </div>
              <div className="contactusformsection__content__left__content__info__all">
                <div className="contactusformsection__content__left__content__info">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5209 4.15045C15.4961 5.37188 15.0582 6.50549 14.4951 7.58322C12.5556 11.2954 9.77069 14.2718 5.50752 15.8751C3.45742 16.6468 1.65176 16.1026 0.420829 14.4288C0.0978177 13.9911 0.103638 13.5334 0.461569 13.1329C1.10468 12.4131 1.7638 11.7026 2.45929 11.024C3.03984 10.4585 3.65239 10.4652 4.32024 10.9774C4.74656 11.3047 5.17869 11.6294 5.57591 11.986C5.88146 12.2614 6.12008 12.2481 6.45037 12.0166C8.50483 10.5796 10.1053 8.79933 11.3363 6.72636C11.5211 6.41501 11.4672 6.19681 11.1791 5.97727C10.7514 5.65129 10.3265 5.31998 9.92783 4.96473C9.3662 4.46445 9.30799 3.90563 9.79106 3.36676C10.4036 2.68154 11.0395 2.00962 11.7 1.36298C12.2849 0.789518 12.8073 0.752263 13.4955 1.23126C14.0149 1.59183 14.5038 1.99498 14.9709 2.41144C15.4976 2.88644 15.5296 3.51711 15.5209 4.15045Z"
                      fill="#DB6220"
                    />
                  </svg>
                  <a
                    className="contactusformsection__content__left__content__info"
                    href="tel:"
                  >
                    {" "}
                    030303030303{" "}
                  </a>
                </div>
                <div className="contactusformsection__content__left__content__info">
                  <svg
                    width="17"
                    height="14"
                    viewBox="0 0 17 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.0797 0.897949H2.27969C1.39969 0.897949 0.687687 1.59795 0.687687 2.4535L0.679688 11.7868C0.679688 12.6424 1.39969 13.3424 2.27969 13.3424H15.0797C15.9597 13.3424 16.6797 12.6424 16.6797 11.7868V2.4535C16.6797 1.59795 15.9597 0.897949 15.0797 0.897949ZM14.7597 4.2035L9.10369 7.64128C8.84769 7.79684 8.51169 7.79684 8.25569 7.64128L2.59969 4.2035C2.39969 4.07906 2.27969 3.86906 2.27969 3.6435C2.27969 3.12239 2.86369 2.81128 3.31969 3.0835L3.95361 3.46893C6.85706 5.23423 10.5023 5.23423 13.4058 3.46893L14.0397 3.0835C14.4957 2.81128 15.0797 3.12239 15.0797 3.6435C15.0797 3.86906 14.9597 4.07906 14.7597 4.2035Z"
                      fill="#DB6220"
                    />
                  </svg>
                  <a
                    className="contactusformsection__content__left__content__info"
                    href="info@knightshomesservices.com"
                  >
                    info@knightshomesservices.com
                  </a>
                </div>
              </div>
              <div className="contactusformsection__content__left__content__info__all">
                <div className="contactusformsection__content__left__content__info">
                  <svg
                    width="14"
                    height="20"
                    viewBox="0 0 14 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.6645 0.340063C10.381 0.376597 13.2546 3.1336 13.0549 6.50099C12.9915 7.56583 12.5072 8.53711 12.0902 9.51552C10.6763 12.8312 8.89596 15.9955 7.2706 19.2247C7.13028 19.5036 6.90031 19.5259 6.64598 19.5419C6.29616 19.5633 6.07398 19.3931 5.92782 19.1098C5.35972 18.0111 4.777 16.9195 4.21475 15.819C2.98014 13.4042 1.78352 10.9769 0.716511 8.49255C-0.587291 5.45843 0.708715 3.07568 2.45686 1.72035C3.66614 0.782039 5.07323 0.318677 6.6645 0.340063ZM6.60993 3.91864C5.16775 3.9231 4.05494 4.94249 4.06176 6.25505C4.06859 7.54712 5.22135 8.59236 6.63429 8.58612C8.05697 8.57988 9.17465 7.54445 9.17368 6.23367C9.17173 4.91665 8.06184 3.91419 6.60993 3.91864Z"
                      fill="#DB6220"
                    />
                  </svg>
                  4926 native dancer lane Orlando 32826
                </div>
              </div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.645878998284!2d-81.16958531273072!3d28.610398522383406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e76829c232278b%3A0xd6bd5e6a9db62381!2s4926%20Native%20Dancer%20Ln%2C%20Orlando%2C%20FL%2032826%2C%20USA!5e0!3m2!1sen!2s!4v1737028635217!5m2!1sen!2s"
                width="100%"
                height="320"
                style={{ border: "0", borderRadius: "30px", marginTop: "20px" }}
                allowFullScreen=""
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      <footer className="Footer">
        <div className="footerbackground">
          <img loading="lazy" src={PngFooterback} alt="" />
        </div>
        <div className="footer__overlay">
          <div className="Footer__content">
            <div className="Footer__content__left">
              <div
                className="Footer__content__left__logo"
                title="Knights Home Service"
              >
                <img src={PngLogo} alt="img" />
              </div>
              <div className="Footer__content__left__logo__info">
                Our company offers professional home appliance repair services
                and top-notch cleaning services. Our goal is to provide our
                customers with excellent service and satisfaction, which is why
                we offer affordable prices and flexible scheduling options.
              </div>
            </div>
            <div className="Footer__content__mid">
              <div className="Footer__content__mid__content">
                <div className="Footer__content__mid__content__left">
                  <div className="Footer__content__mid__content__left__heading">
                    Quick Links
                  </div>
                  <div className="Footer__content__mid__content__left__links">
                    <Link to="#" onClick={scrollToTop}>
                      Home
                    </Link>
                    <Link to="#" onClick={scrollToTop}>
                      About Us
                    </Link>

                    <Link to="#" onClick={scrollToTop}>
                      Contact Us
                    </Link>
                  </div>
                </div>
                <div className="Footer__content__mid__content__left">
                  <div className="Footer__content__mid__content__left__heading">
                    Company
                  </div>
                  <div className="Footer__content__mid__content__left__links">
                    <Link onClick={scrollToTop} to="#">
                      Privacy Statement
                    </Link>
                    <Link onClick={scrollToTop} to="#">
                      Terms of Use
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="Footer__content__right">
              <div className="Footer__content__mid__content__left__heading">
                Stay Updated with us
              </div>
              <div className="Footer__content__right__input__name">
                Your Email
              </div>
              <div className="Footer__content__right__input__button">
                <input
                  className="Footer__content__right__input__button__email"
                  placeholder="Enter your Email"
                  type="email"
                  name="email"
                  id="email"
                />
                <button title="Subscribe">Submit</button>
              </div>
              <div className="Footer__content__right__all__links">
                <a target="_blank" href="https://www.facebook.com/">
                  <Facebook className="Footer__content__right__all__links__link" />
                </a>
                <a target="_blank" href="https://www.instagram.com/">
                  {" "}
                  <Instagram className="Footer__content__right__all__links__link" />
                </a>
                <a target="_blank" href="https://twitter.com/">
                  <Twitter className="Footer__content__right__all__links__link" />
                </a>

                <a target="_blank" href="https://pk.linkedin.com/">
                  {" "}
                  <Linkedin className="Footer__content__right__all__links__link" />
                </a>
              </div>
            </div>
          </div>
          <div className="Footer__bottom">
            <span className="line"> </span>
            <div className="Footer__bottom__heading">
              Copyright © 2024 by Knights Home Service Home appliance repair
              service
            </div>
          </div>
        </div>
      </footer>
      <div
        className="whatsapp__button"
        style={{
          position: "fixed",
          left: "5px",
          bottom: "10px",
          zIndex: "9999",
          cursor: "pointer",
        }}
      >
        <Link to="https://wa.me/" target="_blank">
          <svg
            width="60"
            height="60"
            viewBox="0 0 292 292"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M243.5 0.0332031H48.19C21.5754 0.0332031 0 21.6086 0 48.2232V243.533C0 270.148 21.5754 291.723 48.19 291.723H243.5C270.115 291.723 291.69 270.148 291.69 243.533V48.2232C291.69 21.6086 270.115 0.0332031 243.5 0.0332031Z"
              fill="url(#paint0_linear_261_3592)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M245.28 143.314C245.28 196.814 201.57 240.194 147.65 240.194C131.152 240.223 114.915 236.077 100.45 228.144L46.4 245.314L64.02 193.314C54.8401 178.253 49.9955 160.951 50.02 143.314C50.02 89.8036 93.73 46.4336 147.66 46.4336C201.59 46.4336 245.29 89.8036 245.29 143.314H245.28ZM147.65 61.8736C102.38 61.8736 65.56 98.4036 65.56 143.324C65.5459 160.504 71.0261 177.239 81.2 191.084L70.94 221.324L102.48 211.324C115.894 220.138 131.6 224.821 147.65 224.794C192.91 224.794 229.74 188.254 229.74 143.344C229.74 98.4336 192.91 61.8736 147.65 61.8736ZM196.95 165.644C196.35 164.644 194.75 164.054 192.37 162.864C189.99 161.674 178.2 155.934 176.01 155.144C173.82 154.354 172.21 153.954 170.63 156.324C169.05 158.694 164.44 164.054 163.04 165.644C161.64 167.234 160.26 167.424 157.86 166.234C155.46 165.044 147.75 162.534 138.61 154.454C133.387 149.654 128.899 144.111 125.29 138.004C123.9 135.634 125.16 134.344 126.34 133.164C127.52 131.984 128.74 130.394 129.93 129.004C130.919 127.793 131.727 126.446 132.33 125.004C132.649 124.351 132.798 123.627 132.761 122.901C132.724 122.176 132.504 121.471 132.12 120.854C131.53 119.664 126.74 107.984 124.74 103.224C122.74 98.4636 120.74 98.6536 119.36 98.6536C118.02 98.7135 116.684 98.8504 115.36 99.0636C115.36 99.0636 110.57 99.6636 108.36 102.064C106.15 104.464 99.98 110.184 99.98 121.864C99.98 133.544 108.55 144.864 109.75 146.424C110.95 147.984 126.3 172.774 150.63 182.284C174.96 191.794 174.97 188.614 179.36 188.214C183.75 187.814 193.51 182.474 195.51 176.924C197.51 171.374 197.51 166.624 196.91 165.644H196.95Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="paint0_linear_261_3592"
                x1="145.84"
                y1="0.0332031"
                x2="145.84"
                y2="291.723"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#4AC14B" />
                <stop offset="1" stop-color="#06853A" />
              </linearGradient>
            </defs>
          </svg>
        </Link>
      </div>
      <div
        className="phone__button"
        style={{
          position: "fixed",
          right: "5px",
          bottom: "10px",
          zIndex: "9999",
          cursor: "pointer",
        }}
      >
        <Link to="tel:+">
          <svg
            width="60"
            height="60"
            viewBox="0 0 292 292"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M243.762 0.0332031H48.4517C21.8371 0.0332031 0.261719 21.6086 0.261719 48.2232V243.533C0.261719 270.148 21.8371 291.723 48.4517 291.723H243.762C270.376 291.723 291.952 270.148 291.952 243.533V48.2232C291.952 21.6086 270.376 0.0332031 243.762 0.0332031Z"
              fill="url(#paint0_linear_261_3591)"
            />
            <path
              d="M87.9406 173.78C86.6119 172.618 85.0672 171.729 83.3949 171.164C81.7226 170.599 79.9554 170.368 78.1941 170.486C76.4329 170.604 74.7121 171.068 73.1301 171.851C71.548 172.634 70.1357 173.721 68.9738 175.05L45.383 202.028C44.2211 203.357 43.3323 204.901 42.7673 206.573C42.2023 208.245 41.9723 210.012 42.0902 211.773C42.2082 213.534 42.6719 215.255 43.4549 216.836C44.2378 218.418 45.3247 219.83 46.6534 220.992L62.9497 235.253C71.7946 242.001 79.7515 241.058 79.8847 241.058C83.2553 240.433 89.9828 241.656 94.9106 240.099C114.093 234.017 141.696 221.75 173.131 185.8C204.566 149.851 214.828 118.767 219.78 97.2461C221.32 90.5493 219.616 82.8178 220.046 78.7471C220.046 78.614 220.319 70.7322 213.489 64.7457C213.069 64.3869 212.68 63.9939 212.325 63.5709L201.028 53.4762L196.346 49.7539C193.662 47.4084 190.156 46.225 186.599 46.4638C183.042 46.7027 179.726 48.3443 177.379 51.0277L153.789 78.0061C152.624 79.3353 151.733 80.8811 151.166 82.555C150.6 84.229 150.369 85.9982 150.487 87.7615C150.605 89.5248 151.069 91.2475 151.854 92.831C152.638 94.4146 153.728 95.8279 155.059 96.99L175.385 114.748C167.599 130.167 159.194 144.441 144.752 160.956C132.158 175.364 121.53 183.97 109.445 192.572L87.9406 173.78Z"
              fill="white"
            />
            <path
              d="M60.3987 233.017L62.9532 235.254C71.798 242.002 79.7549 241.059 79.8881 241.059C83.2587 240.434 89.9862 241.657 94.9141 240.1C114.096 234.018 141.699 221.751 173.134 185.801C204.569 149.852 214.828 118.768 219.78 97.2472C221.32 90.5504 219.616 82.8188 220.046 78.7482C220.05 77.472 219.897 76.2001 219.592 74.9609C210.515 164.079 129.542 213.784 60.3987 233.017Z"
              fill="white"
            />
            <path
              d="M182.15 53.5957L168.131 69.6154C174.514 63.185 190.752 51.2496 211.229 69.1817L192.631 52.9025C191.146 51.6107 189.211 50.9586 187.247 51.0885C185.284 51.2184 183.451 52.1197 182.15 53.5957Z"
              fill="white"
            />
            <path
              d="M73.9938 178.852L59.9616 194.872C66.3442 188.441 82.5825 176.506 103.059 194.441L84.4642 178.159C82.9806 176.869 81.0475 176.218 79.0862 176.348C77.1249 176.478 75.2944 177.378 73.9938 178.852Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="paint0_linear_261_3591"
                x1="146.102"
                y1="0.0332031"
                x2="146.102"
                y2="291.723"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#4AC14B" />
                <stop offset="1" stop-color="#06853A" />
              </linearGradient>
            </defs>
          </svg>
        </Link>
      </div>
    </>
  );
}
function Input({ textarea, required, label, error, list, ...props }) {
  return (
    <div className="contact__content__left__input">
      <label
        htmlFor={props.id}
        className="contact__content__left__input__label"
      >
        {label}
        {required ? <span>*</span> : null}
      </label>
      {textarea ? (
        <textarea
          {...props}
          cols="30"
          rows="10"
          className="contact__content__left__input__field"
          required={required}
          style={{ padding: "1em" }}
        />
      ) : (
        <input
          {...props}
          className="contact__content__left__input__field"
          required={required}
          list={label + "s"}
          id={label}
        />
      )}
      {error !== "" ? (
        <div className="contact__content__left__input__error">{error}</div>
      ) : null}
      {list ? (
        <datalist id={label + "s"}>
          {list.map((item, i) => (
            <option key={i} value={item} />
          ))}
        </datalist>
      ) : null}
    </div>
  );
}
function Textareas({ textarea, required, label, error, list, ...props }) {
  return (
    <div className="contact__content__left__input">
      <label
        htmlFor={props.id}
        className="contact__content__left__input__label"
      >
        {label}
        {required ? <span>*</span> : null}
      </label>
      {textarea ? (
        <textarea
          {...props}
          cols="30"
          rows="10"
          className="contact__content__left__input__field__textarea"
          required={required}
          style={{ padding: "1em" }}
        />
      ) : (
        <input
          {...props}
          className="contact__content__left__input__field__textarea"
          required={required}
          list={label + "s"}
          id={label}
        />
      )}
      {error !== "" ? (
        <div className="contact__content__left__input__error">{error}</div>
      ) : null}
      {list ? (
        <datalist id={label + "s"}>
          {list.map((item, i) => (
            <option key={i} value={item} />
          ))}
        </datalist>
      ) : null}
    </div>
  );
}
